import { render, staticRenderFns } from "./selaReviewStats.vue?vue&type=template&id=67ae5bab&scoped=true"
import script from "./selaReviewStats.vue?vue&type=script&lang=js"
export * from "./selaReviewStats.vue?vue&type=script&lang=js"
import style0 from "./selaReviewStats.vue?vue&type=style&index=0&id=67ae5bab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../photo-retention-20261014/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ae5bab",
  null
  
)

export default component.exports